<template>
  <component :is="tag" @click="toggle">
    <slot>How It Works</slot>
  </component>
</template>

<script>

export default {
  name: 'header-how-it-works-button',
  props: {
    tag: {
      type: String,
      default: 'span',
    },
  },
  methods: {
    toggle () {
      if (this.$howitworks) {
        this.$howitworks.toggle();
      }
    },
  },
};
</script>
